<template>
    <div class="base-data-table-container" :style="styles.container">
        <slot v-if="isMobile" name="mobile-view" :mobileData="mobileData"></slot>
        <table v-else :style="styles.table">
            <thead>
                <tr :style="styles.header">
                    <th
                        v-for="(header, indx) in table.headers"
                        :key="indx"
                        :style="styles.headerSpacing"
                    >
                        <slot
                            name="table-header"
                            :headers="table.headers"
                            :header="header"
                            :sortBy="sortBy"
                        ></slot>
                    </th>
                </tr>
            </thead>
            <base-pagination :maxData="maxRow" :data="table.rows">
                <template #content="{ paginatedData }">
                    <tbody>
                        <tr
                            v-for="(row, indx) in paginatedData"
                            :key="indx"
                            :style="styles.row"
                        >
                            <td
                                v-for="cell in row"
                                :key="cell.accessor"
                                :style="styles.rowSpacing"
                            >
                                <slot :cell="cell" name="table-cell"></slot>
                            </td>
                        </tr>
                    </tbody>
                </template>
                <template
                    #paginator="{
                        totalPages,
                        currentPage,
                        paginatedPages,
                        nextPage,
                        prevPage
                    }"
                >
                    <slot
                        name="paginator"
                        :totalPages="totalPages"
                        :currentPage="currentPage"
                        :paginatedPages="paginatedPages"
                        :nextPage="nextPage"
                        :prevPage="prevPage"
                    ></slot>
                </template>
            </base-pagination>
        </table>
    </div>
</template>
<script>
    import { useTable } from '@/composables/ui/useTable'
    import useCheckScreen from '@/composables/useCheckScreen'
    import BasePagination from '@/components/ui/pagination/BasePagination'

    export default {
        name: 'BaseDataTable',
        components: { BasePagination },
        props: {
            columns: {
                required: true,
                type: Array
            },
            originalData: {
                required: true,
                type: Array
            },
            maxRow: {
                required: true,
                type: Number
            },
            styles: {
                required: false,
                type: Object,
                default: () => ({
                    container: {},
                    table: {},
                    header: {},
                    row: {}
                }),
                validator: (v) =>
                    Object.keys(v).some((key) =>
                        [
                            'container',
                            'table',
                            'header',
                            'headerSpacing',
                            'row',
                            'rowSpacing'
                        ].includes(key)
                    )
            }
        },
        setup(props) {
            const { isMobile } = useCheckScreen()
            const { table, mobileData, sortBy } = useTable(props)

            return { isMobile, table, mobileData, sortBy }
        }
    }
</script>
<style lang="scss" scoped>
    .base-data-table-container {
        width: 100%;
    }
</style>
